module.exports = {
  notAvailable: 'Webshop ist aktuell nicht verfügbar',
  webshop: 'Webshop',
  eng: 'English',
  de: 'Deutsch',
  error404: 'Die gesuchte Seite existiert nicht!',
  invalid: 'Ungültig',
  abr: 'Abkürzung',
  name: 'Name',
  phone: 'Telefonnr.',
  persons: 'Kontakte',
  call: 'Anruf',
  total: 'Gesamt',
  status: 'Status',
  type: 'Typ',
  restaurant: 'Restaurant',
  all: 'Alle',
  none: 'Keine',
  allNone: 'Alle/Keine',
  date: 'Datum',
  paymentMethods: 'Zahlungsmethoden',
  paymentReports: 'Zahlungsberichte',
  deliveryMethods: 'Zustellart',
  openPayments: 'Offene Zahlungen',
  card: 'Karte',
  cash: 'Bar',
  amazon: 'Amazon',
  cardmanual: 'Karte manuell',
  deliveroo: 'Deliveroo',
  hungryhouse: 'Hungry House',
  invoice: 'Rechnung',
  justeat: 'Justeat',
  ubereats: 'Ubereats',
  voucher: 'Gutschein',
  galaxycard: 'Galaxy Card',
  collection: 'Abholung',
  delivery: 'Lieferung',
  website: 'Webseite',
  taxReport: 'Steuerbericht',
  itemUsage: 'Artikelverkauf',
  cancellationReason: 'Stornierungsgrund',
  cancellationReasonFalseEntry: 'Fehleingabe',
  cancellationReasonGoodWill: 'Kulanz',
  cancellationReasonComplaint: 'Reklamation',
  cancellationReasonReturn: 'Retournierung',
  vattotal: 'MwSt. Gesamt',
  label: 'Etikett',
  driver: 'Fahrer',
  collectAll: 'Alle einsammeln',
  open: '***Open',
  sale: '***Sale',
  registerCard: 'Karte anmelden',
  cardDetails: 'Karten Details',
  walletDetails: 'Etui Details',
  confirmed: 'Bestätigt',
  pending: '***Pending',
  canceled: '***Canceled',
  shoppingBasket: 'Einkaufskorb',
  zNonTraining: 'Regulär',
  zTraining: 'Training',
  orderDetails: 'Bestellübersicht',
  sysVersion: 'Backend Version',
  resourceId: 'Webshop ID',
  orange: 'Orange',
  blue: 'Blau',
  green: 'Grün',
  orderFees: 'Zustellgebühren',
  openingHours: 'Öffnungszeiten',
  quickLinks: 'Quicklinks',
  forgotPassword: 'Kennwort vergessen?',
  allRights: 'ALLE Rechte vorbehalten',
  selectMethod: 'Bitte Methode wählen',
  byEmail: 'Zurücksetzen mittels Email',
  byPhone: 'Zurücksetzen mittels Telefonnr.',
  deliveryMethod: 'Zustellart',
  paymentProgress: 'Zahlung wird durchgeführt',
  pleaseWait: 'Bitte wählen',
  selectTime: 'Zeit wählen',
  orderHistory: 'Bestellungshistorie',
  attention: 'Bitte BEACHTEN',
  foodAllergy: 'Wenn Sie - oder jemand für den Sie bestellen - eine Allergie hat, bitte',
  callRestaurant: 'kontaktieren Sie das Restaurant',
  language: 'Sprachen',
  english: 'English',
  german: 'Deutsch',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
  colours: 'Farben',
  experiment: 'Experiment',
  feVersion: 'Frontend Version',
  theme: 'Theme',
  light: 'Light',
  dark: 'Dark',
  backTo: 'ZURÜCK ZU',
};



// WEBPACK FOOTER //
// ./src/lang/de/global.js